/// <amd-module name="Build/Admin/Common/Stores/VirtualMachineScaleSetStore" />
import { Store } from "VSS/Reflux/Store";

import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

import { VirtualMachineScaleSet } from "Build/Admin/Common/Client/Contracts/DistributedTask/Azure";
import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IVirtualMachineScaleSetStoreState {
    serviceEndpoint: ServiceEndpoint | undefined;
    virtualMachineScaleSets: VirtualMachineScaleSet[];
    virtualMachineScaleSetsStatus: StoreStatus;
    virtualMachineScaleSetsErrorMessage: string | undefined;
}

export class VirtualMachineScaleSetStore extends Store {
    public state: IVirtualMachineScaleSetStoreState = {
        serviceEndpoint: undefined,
        virtualMachineScaleSets: [],
        virtualMachineScaleSetsStatus: StoreStatus.None,
        virtualMachineScaleSetsErrorMessage: undefined
    };

    constructor() {
        super("VirtualMachineScaleSetStoreChanged");
    }

    public updateVirtualMachineScaleSets = (virtualMachineScaleSets: VirtualMachineScaleSet[]): void => {
        this.state = {
            ...this.state,
            virtualMachineScaleSets: this._sortVirtualMachineScaleSets(virtualMachineScaleSets.slice(0)),
            virtualMachineScaleSetsStatus: StoreStatus.Loaded,
            virtualMachineScaleSetsErrorMessage: undefined
        };

        this.emitChanged();
    }

    public updateVirtualMachineScaleSetsError = (errorMessage: string | undefined): void => {
        this.state = {
            ...this.state,
            virtualMachineScaleSetsErrorMessage: errorMessage
        };

        this.emitChanged();
    }

    public updateVirtualMachineScaleSetsStatus = (virtualMachineScaleSetsStatus: StoreStatus): void => {
        this.state = {
            ...this.state,
            virtualMachineScaleSetsStatus
        };

        this.emitChanged();
    }

    private _sortVirtualMachineScaleSets(virtualMachineScaleSets: VirtualMachineScaleSet[]): VirtualMachineScaleSet[] {
        return (virtualMachineScaleSets).sort((a, b) => {
            return localeIgnoreCaseComparer(a.name, b.name);
        });
    }
}
